import React from 'react';
import {
  useCohortRowContext,
  useCohortRowOperatorAndValues,
} from '../CohortRowContext';
import CohortRowOperatorValue from './CohortRowOperatorValue';

const CohortRowSingleOperatorValue = () => {
  const { rowMeta, cohortRow } = useCohortRowContext();
  const { simpleCohortTypeKey } = cohortRow;
  const { operatorValues = [] } = useCohortRowOperatorAndValues();
  return (
    <CohortRowOperatorValue
      simpleCohortTypeKey={simpleCohortTypeKey}
      value={operatorValues?.[0] ?? null}
      rowMeta={{
        ...rowMeta,
        numberIndex: 0,
      }}
    />
  );
};

export default CohortRowSingleOperatorValue;
